import { Helmet } from "react-helmet-async";
import React, { useState, useEffect } from "react";
import PageBanner from "../Components/PageBanner";

export default function TermsAndConditions() {
  return (
    <>
      {/* Meta Tags for SEO & Social Media */}
      <Helmet>
        {/* Basic SEO */}
        <title>Terms & Conditions | Urban View Real Estate PVT LTD</title>
        <meta
          name="description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta
          name="keywords"
          content="Affordable Homes for Sale in South Australia, Affordable Homes for Sale in Melbourne, Affordable Homes for Sale in Queensland, Development Sites for Sale in Sydney, Cheap Rent a Home in Penrith, House Buying in Western Australia, Cheap Duplex Home in Tamworth, Affordable duplex Home in Armidale, Houses for Rental in St Marys, Investement Property in Queensland, Best Investment Property Sale in Brisbane, Best Investment Property Sale in Rouse Hill, Box Hill, Marsden Park, Vineyard, Investment Property Buy in Austral, Investment Property Buy in Tallawong, Investment Property Buy in Oran Park, Investment Property Buy in Leppington"
        />

        <meta name="author" content="Urban View Real Estate PVT LTD" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://urbanviewre.com/terms-and-conditions" />

        {/* Open Graph */}
        <meta property="og:title" content="Urban View Real Estate PVT LTD" />
        <meta
          property="og:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta property="og:site_name" content="Urban View Real Estate" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://urbanviewre.com" />
        <meta
          property="og:image"
          content="https://urbanviewre.com/assets/logo-2-CGgGTWZk.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Urban View Real Estate PVT LTD" />
        <meta
          name="twitter:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta
          name="twitter:image"
          content="https://urbanviewre.com/assets/logo-2-CGgGTWZk.png"
        />
        <meta name="twitter:site" content="@urbanviewre" />
        <meta name="twitter:creator" content="@urbanviewre" />

        {/* Facebook  */}
        <meta
          property="fb:admins"
          content="https://www.facebook.com/profile.php?id=61559035348971"
        />

        {/* Instagram */}
        <meta name="instagram:title" content="Urban View Real Estate PVT LTD" />
        <meta
          name="instagram:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta name="instagram:site" content="@urbanviewrealestate" />
      </Helmet>
      <>
        <PageBanner
          title="Terms & Conditions"
          breadcrumbs={[
            { label: "Home", href: "/", icon: "bi-house-door-fill" },
            { label: "Terms & Conditions", active: true },
          ]}
        />

        {/* Stats */}
        <section className="py-5 bg-light">
          <div className="container py-5">
            <div className="row justify-content-center">
              <h4 className="brand mb-4">
                Privacy Policy for UrbanView Real Estate
              </h4>
              <p className="text-secondary lh-lg">
                At UrbanView Real Estate, we are committed to protecting your
                privacy and ensuring the security of your personal information.
                This Privacy Policy outlines how we collect, use, disclose, and
                safeguard your information when you interact with our services.
                <br />
                Information We Collect We may collect the following types of
                information:
                <br /> Personal Information: Includes your name, contact
                details, address, and other identifiers necessary for real
                estate transactions.
                <br /> Financial Information: If applicable, we may collect
                financial information necessary for processing transactions,
                such as credit card details or mortgage information.
                <br /> Usage Data: Information about your interactions with our
                website, including IP addresses, browser type, pages visited,
                and similar data.
                <br /> How We Use Your Information
                <br /> We use your information for the following purposes:
                <br /> Providing Services: To facilitate real estate
                transactions, property management, or related services you
                request.
                <br /> Communication: To communicate with you regarding
                properties, transactions, updates, or marketing materials, where
                permitted by law.
                <br /> Improving Services: To analyze trends and improve our
                services, website functionality, and user experience.
                Information Sharing and Disclosure <br /> We may share your
                information under the following circumstances:
                <br /> With Service Providers: To facilitate services you
                request, such as property inspections, appraisals, or mortgage
                processing.
                <br /> Legal Compliance: To comply with legal obligations or in
                response to lawful requests from authorities.
                <br /> Data Security <br /> We implement reasonable measures to
                protect your information from unauthorized access, alteration,
                disclosure, or destruction. However, no method of transmission
                over the internet or electronic storage is 100% secure.
                <br /> Your Choices and Rights
                <br /> You have the right to:
                <br /> Access, correct, or update your personal information.
                <br /> Opt-out of marketing communications.
                <br /> Request deletion of your personal information, subject to
                legal requirements.
                <br /> Changes to This Privacy Policy <br />
                We may update this Privacy Policy periodically. We will notify
                you of any changes by posting the updated policy on our website.
                <br /> Contact Us
                <br /> If you have questions or concerns about this Privacy
                Policy or our practices, please contact us at:
              </p>
              <span className="text-secondary lh-lg">
                UrbanView Real Estate
              </span>
              <span className="text-secondary lh-lg">
                Suite 5/429 High Street, Penrith, NSW 2750
              </span>
              <span className="text-secondary lh-lg">
                Email: urbanview@urbanviewre.com
              </span>
              <span className="text-secondary lh-lg">Phone: 0424 955 982</span>
            </div>
          </div>
        </section>
      </>
    </>
  );
}
